import { render } from "./weixin.vue?vue&type=template&id=3b0ac162&scoped=true"
import script from "./weixin.vue?vue&type=script&lang=js"
export * from "./weixin.vue?vue&type=script&lang=js"

import "./weixin.vue?vue&type=style&index=0&id=3b0ac162&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Code\\vue\\xypt-admin-wx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0ac162"]])

export default __exports__